<template>
    <div class="footer py-2">
        <v-container>
            <v-row no-gutters>
                <v-col cols="12" sm="12" md="4">
                    <h2 class="text-gold font-dancing-script-400">One Registration, Endless Connections</h2>
                </v-col>
                <v-col cols="12" sm="12" md="8">
                    <v-row class="white--text">
                        <v-col md="6" sm="12">
                            <div class="text-xs">Powered By</div>
                            <div>LiveAlbum</div>
                        </v-col>
                        <v-divider vertical></v-divider>
                        <v-col md="6" sm="12">
                            <div class="text-xs">Organized By</div>
                            <div>MAGNUS EVENTUS INC.</div>
                            <p class="text-sm white--text"> +63 917 107 6989 / +63 917 862 4687 <br/>+63 917 133 3898 / +63 917 539 4621 <br/>
                                <v-icon size="18" class="white--text">mdi-email-outline</v-icon> info@magnuseventus.com</p>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
    export default {
        name: 'Footer',
    }
</script>
<style scoped>
    .footer {
        background : #1a3765;
    }
    .text-gold {
        color : #9c6b00;
    }
    .text-sm {
        font-size: 13px;
    }
</style>